import axios from "axios";
import { useState } from "react";
import { useSelector } from "react-redux";
import { PublicKey } from "@solana/web3.js";

function useContractInit() {
  const [tokenSaleConfigAddress, setTokenSaleConfigAddress] = useState("");
  const [tokenAuthority, setTokenAuthority] = useState("");
  const [tokenMintAddress, setTokenMintAddress] = useState("");
  const [solanaReceiverAddress, setSolanaReceiverAddress] = useState("");
  const [saleAuthority, setSaleAuthority] = useState("");
  const [saleAuthorityAddress, setSaleAuthorityAddress] = useState("");
  const [deploymentWalletAddress, setDeploymentWalletAddress] = useState("");
  const [tokenQuantity, setTokenQuantity] = useState({});
  const [slotReleaseDate, setSlotReleaseDate] = useState({});

  const user = useSelector((state) => state.userStore.user);
  const token = user.auth;

  const getTokenInitializationDetails = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT_URL}/deployment/tokenBuySmartContractInfo`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    const responseData = response?.data?.data;
    if (responseData?.status === true) {
      const tokenSaleConfig = new PublicKey(
        responseData?.tokenSaleConfigAddress
      );
      setTokenSaleConfigAddress(tokenSaleConfig);
      const tokenAuthorityAPI = new PublicKey(responseData?.tokenAuthority);
      setTokenAuthority(tokenAuthorityAPI);
      const tokenMintAPI = new PublicKey(responseData?.tokenAddress);
      setTokenMintAddress(tokenMintAPI);
      const solanaReceiverAddressAPI = new PublicKey(
        responseData?.solanaReceiverAddress
      );
      setSolanaReceiverAddress(solanaReceiverAddressAPI);
      const saleAuthorityAPI = new PublicKey(responseData?.saleAuthority);
      setSaleAuthority(saleAuthorityAPI);
      setSaleAuthorityAddress(responseData?.saleAuthority);
      setTokenQuantity(responseData?.tokenQuantities);
      setSlotReleaseDate(responseData?.slotReleaseTimes);
      setDeploymentWalletAddress(responseData?.deploymentwalletAddress);
    } else {
      console.warn("Invalid response of token initialization");
    }
  };

  return {
    tokenSaleConfigAddress,
    tokenAuthority,
    tokenMintAddress,
    solanaReceiverAddress,
    saleAuthority,
    saleAuthorityAddress,
    tokenQuantity,
    slotReleaseDate,
    deploymentWalletAddress,
    getTokenInitializationDetails,
  };
}

export default useContractInit;
